import apiCaller from '../../utils/apiCaller'

const CHECKUP_INITIALIZE = () => {
    return {
        step: 0,

        waistCm: 0, // 허리 둘레
        waistInch: '',
        waistUnit: 'cm',

        heightCm: 0,
        heightFeet: '',
        heightInch: '',
        heightUnit: 'cm',

        weightKg: 0,
        weightLb: '',
        weightUnit: 'kg',

        bmi: 0,

        bpLow: 0, // 최저 혈압
        bpHigh: 0, // 최고혈압

        oligProteCd: '',
        dfabPtnCd: 0,


        drnkHabit: null, //음주일수
        drnkType: null,
        drnkQty: null, // 주량 수

        smkStatType: null,
        smkTerm: null,
        smkQty: null,

        mov20WekFreq: 0,
        mov30WekFreq: 0,
        wlk30WekFreq: 0,

        totChole: 0, //	총콜레스테롤
        triglyceride: 0, //	중성지방(트리글리세라이드)
        hdlChole: 0, //	HDL-콜레스테롤
        ldlChole: 0, //	LDL-콜레스테롤
        sgotAst: 0, //	(혈청지오티)AST
        sgptAlt: 0, //	(혈청지피티)ALT
        gammaGtp: 0, //	감마지티피(γ-GTP)
        creatinine: 0, //	혈청크레아티닌
        hmg: 0, //	혈색소
        blds: 0, //	공복 혈당

        hchk: '',
        fmly: '',

        regDate: ''
    }
}

export const state = {
    step: 0,
    checkUp: CHECKUP_INITIALIZE(),
    checkupTemp: {  // 엔진에 보낼 값은 아니지만 저장해 놓아야 하는 항목을 저장하기 위한 오브젝트
      bpSelected: null
    },
    checkupNo: null,    
    checkupResult: null,
}

export const getters = {
    getStep: (state) => state.step,
    checkUp: (state) => state.checkUp,
    checkupTemp: (state) => state.checkupTemp,
    checkupNo: (state) => state.checkupNo,
    checkupResult: (state) => state.checkupResult
}

export const mutations = {
    SET_STEP(state, step) {
        state.step = step
    },
    CLEAR_CHECKUP_TEMP(state, payload) {        
        state.step = 0
        state.checkUp = CHECKUP_INITIALIZE()
        state.checkupTemp = { bpSelected: null}
        state.checkupNo = null
        state.checkupResult = null
        console.log('CLEAR_CHECKUP_TEMP', state)
    },
    SET_CHECKUP_RESULT(state, result) {
        state.checkupResult = result
    },
    SET_CHECKUP_TEMP(state, payload) {
        state.checkUp.step = payload.step

        if (payload.step === 3) {
            state.checkUp.heightCm = payload.height
            state.checkUp.weightKg = payload.weight
            state.checkUp.bmi = payload.bmi
        } else if (payload.step === 4) {
            state.checkUp.bpLow = payload.bpLow
            state.checkUp.bpHigh = payload.bpHigh
            state.checkupTemp.bpSelected = payload.bpSelected
        } else if (payload.step === 5) {
            state.checkUp.drnkHabit = payload.drnkHabit
        } else if (payload.step === 51) {
            state.checkUp.drnkType = payload.drnkType
            state.checkUp.drnkQty = payload.drnkQty
        } else if (payload.step === 6) {
            state.checkUp.smkStatType = payload.smkStatType
            if(payload.smkStatType === 1) {
              state.checkUp.smkTerm = 0
              state.checkUp.smkQty = 0  
            }
        } else if (payload.step === 61) {
            state.checkUp.smkTerm = payload.smkTerm
        } else if (payload.step === 62) {
            state.checkUp.smkQty = payload.smkQty
        } else if (payload.step === 7) {
            state.checkUp.mov20WekFreq = payload.mov20WekFreq
        } else if (payload.step === 8) {
            state.checkUp.mov30WekFreq = payload.mov30WekFreq
        } else if (payload.step === 9) {
            state.checkUp.wlk30WekFreq = payload.wlk30WekFreq
        } else if (payload.step === 41) {
            // stepAdd
            state.checkUp.totChole = payload.totChole
            state.checkUp.triglyceride = payload.triglyceride
            state.checkUp.hdlChole = payload.hdlChole
            state.checkUp.ldlChole = payload.ldlChole
            state.checkUp.sgotAst = payload.sgotAst
            state.checkUp.sgptAlt = payload.sgptAlt
            state.checkUp.gammaGtp = payload.gammaGtp
            state.checkUp.creatinine = payload.creatinine
            state.checkUp.hmg = payload.hmg
            state.checkUp.blds = payload.blds
        } else if (payload.step === 10) {
            state.checkUp.hchk = payload.hchk
        } else if (payload.step === 11) {
            state.checkUp.fmly = payload.fmly
            state.checkUp.fcCode = payload.empCode
        }
    },
    SET_CHECKUP_NO(state, checkupNo) {
      state.checkupNo = checkupNo
    }
}

export const actions = {
    setStep({ commit }, payload) {
        commit('SET_STEP', payload)
    },
    clearCheckupTemp({commit}, payload) {
        commit('CLEAR_CHECKUP_TEMP', payload)
    },
    setCheckupTemp({ commit }, payload) {
        commit('SET_CHECKUP_TEMP', payload)
    },
    setCheckupNo({commit}, payload) {
        commit('SET_CHECKUP_NO', payload)
    },
    async requestCheckup({}, payload ) {
        return await apiCaller.checkUp.add2(payload)
    },
    async requestCheckupAgain({}, payload) {
        return await apiCaller.checkUp.modify2(payload)
    },
    async getCheckupResult({commit, state}, payload) {
        const res = await apiCaller.report.detail(payload)
        const resultCode = Number(res.data.code)
        if(resultCode === 200) {
            const report = res.data.result.reportInfo
            console.log(report)

            // 폐암 보정
            let smokeScore = (state.checkUp.smkTerm * 365) * state.checkUp.smkQty
            if(smokeScore > 1800) {
                report.lungIndex++
            }
            else if(smokeScore > 7000) {
                report.lungIndex += 2
            }
            else if(report.lungIndex > 0 && smokeScore <= 1800) {
                report.lungIndex = 0
            }

            // 간암 보정
            let drinkScore = (state.checkUp.drnkHabit * 365/7) * state.checkUp.drnkQty
            if(drinkScore > 200) {
                report.liverIndex++
            }
            else if(drinkScore > 700) {
                report.liverIndex += 2
            }
            else if(report.liverIndex > 0 && drinkScore <= 200) {
                report.liverIndex = 0
            }            

            commit('SET_CHECKUP_RESULT', report)
            /*
                checkupNo: 35
                gender: "1"
                displayAge: "42세"
                name: "1"
                displayGender: "남"
                displayCheckupDate: "2020.04.08"
                displayBirthday: "1977.09.12"
                dmIndex: 0
                dementiaIndex: 0
                stomachIndex: 3
                liverIndex: 1
                colorectalIndex: 2
                breastIndex: 3
                lungIndex: 3
                prostateIndex: 3
                heartIndex: 2
                strokeIndex: 1
                topDisease: "STOMACH"
                topRank: 98
                topRiskIndex: 3
            */
        }        
        return res
    },    
}

export default {
    namespaced: true,
    actions,
    getters,
    mutations,
    state
}
